export const f =
  typeof fetch !== 'undefined'
    ? fetch
    : ((() => {
        throw new Error('fetch is not defined');
      }) as any as typeof fetch);
